import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'

import DropdownRedux from 'components/dropdown-redux'

import { MORTGAGE_SORTING_FORM_NAME } from '../common/constants'

/*
  Basic redux form to handle the sorting of product results.
*/
const SortingForm = (props) => {
  const { className, sortingOptions } = props
  return (
    <form className={className} onSubmit={() => {}}>
      <DropdownRedux
        label="Order by"
        name="sorting"
        className={className}
        options={sortingOptions}
      />
    </form>
  )
}

SortingForm.propTypes = {
  className: PropTypes.string,
  sortingOptions: PropTypes.arrayOf(PropTypes.shape({})),
}
export default reduxForm({
  form: MORTGAGE_SORTING_FORM_NAME,
  destroyOnUnmount: false,
})(SortingForm)
